module.exports = __webpack_public_path__ + "static/media/9_I wish you enough_RU.8930f1cc.txt";